export enum DTMFS_TABLE_COLUMNS {
    CODE = 'Code',
    DESCRIPTION = 'Description',
    ACTION = 'Action',
    ACTIONS = 'Actions',
}

export const DTMFS_DEFAULT_SORT_COLUMN = DTMFS_TABLE_COLUMNS.CODE;
export const DTMFS_DEFAULT_SORT_COLUMN_DIRECTION = 'asc';
export const DTMFS_PAGE_SIZE_OPTIONS = [10, 15, 20, 25];
export const DTMFS_PAGE_DEFAULT_SIZE = 20;
export const DTMFS_MAX_MEMORY_SIZE = 20;

export const DTMFS_TABLE_HEADER = [
    DTMFS_TABLE_COLUMNS.CODE,
    DTMFS_TABLE_COLUMNS.DESCRIPTION,
    DTMFS_TABLE_COLUMNS.ACTION,
    DTMFS_TABLE_COLUMNS.ACTIONS,
];
